document.addEventListener("DOMContentLoaded", function () {
  const countdownElement = document.getElementById("countdown");

  // If countdown element doesn't exist, exit early
  if (!countdownElement) return;

  // Get the target date from the data attribute
  const targetDateStr = countdownElement.getAttribute("data-target-date");
  const raceDate = new Date(targetDateStr).getTime();

  function updateCountdown() {
    const now = new Date().getTime();
    const distance = raceDate - now;

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    document.getElementById("countdown-days").textContent = days;
    document.getElementById("countdown-hours").textContent = hours;
    document.getElementById("countdown-minutes").textContent = minutes;
    document.getElementById("countdown-seconds").textContent = seconds;

    if (distance < 0) {
      clearInterval(timer);
      countdownElement.innerHTML =
        '<div class="countdown__finished">Race has started!</div>';
    }
  }

  updateCountdown();
  const timer = setInterval(updateCountdown, 1000);
});
